var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-grid kt-grid--ver kt-grid--root"},[_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-error-v1",style:({
      backgroundImage: `url(${_vm.backgroundImage})`
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-error-v1__container"},[_c('h1',{staticClass:"kt-error-v1__number"},[_vm._v("404")]),_c('p',{staticClass:"kt-error-v1__desc"},[_vm._v(" OOPS! Something went wrong here ")])])
}]

export { render, staticRenderFns }